import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7.70711 9.79289C7.31658 9.40237 6.68342 9.40237 6.29289 9.79289C5.90237 10.1834 5.90237 10.8166 6.29289 11.2071L11.2929 16.2071C11.6834 16.5976 12.3166 16.5976 12.7071 16.2071L17.7071 11.2071C18.0976 10.8166 18.0976 10.1834 17.7071 9.79289C17.3166 9.40237 16.6834 9.40237 16.2929 9.79289L12 14.0858L7.70711 9.79289Z",
	fill: "black"
}));
export default SvgArrowDown;
